<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">PAR Request View</div>
                    <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">PAR Claim# :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{loadPARData.return_order}}</span>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Credit PO# :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{loadPARData.credit_po}}</span>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Claim Status :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{loadPARData.claim}}</span>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <swiper class="" :options="swiperOptionAttachments" ref="swiperAttachment">
                                <template v-for="(doc, index) in documentArr">
                                    <template v-if="doc.doc_extension.toLowerCase() == 'gif' || doc.doc_extension.toLowerCase() == 'jpg' || doc.doc_extension.toLowerCase() == 'jpeg' || doc.doc_extension.toLowerCase() == 'png'">
                                        <swiper-slide :key="'image ' + index">
                                            <img style="width: 100%; height: 100px; object-fit: cover;" :src="doc.media_path" @click="openGallery(documentArr, index)">
                                        </swiper-slide>
                                    </template>
                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                        <swiper-slide :key="'doc ' + index">
                                            <a :href="doc.media_path" target="_blank"><img src="/static/images/doc-icon.png" class="link-icon"></a>
                                        </swiper-slide>
                                    </template>
                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                        <swiper-slide :key="'xls ' + index">
                                            <a :href="doc.media_path" target="_blank"><img src="/static/images/xl-icon.png" class="link-icon"></a>
                                        </swiper-slide>
                                    </template>
                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                        <swiper-slide :key="'ppt ' + index">
                                            <a :href="doc.media_path" target="_blank"><img src="/static/images/ppt-icon.png" class="link-icon"></a>
                                        </swiper-slide>
                                    </template>
                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                        <swiper-slide :key="'pdf ' + index">
                                            <a :href="doc.media_path" target="_blank"><img src="/static/images/pdf-icon.png" class="link-icon"></a>
                                        </swiper-slide>
                                    </template>
                                    <template v-else>
                                        <swiper-slide :key="'other ' + index">
                                            <a :href="doc.media_path" target="_blank"><img src="/static/images/link-icon.png" class="link-icon"></a>
                                        </swiper-slide>
                                    </template>
                                </template>
                            </swiper>
                        </div>
                    </div>
                    <b-modal size="lg" class="gallery_modal" id="modal1" @cancel="onCancel('main')" ref="myModalRef" hide-footer :hide-header=true>
                        <img class="w-100 mb-3" :src="viewImage">
                        <div class="clearfix"></div>
                        <div class="image-arrows customIconModelFooter clearfix">
                            <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('next')"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                            <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('previous')"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                        </div>
                    </b-modal>
                </div>
                <!--Forms-->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";

    var self;
    var exten = ['gif', 'jpg', 'jpeg', 'png'];
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    /* Swiper for submenu tebs start */
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    /* Swiper for submenu tebs end */

    export default {
        name: 'AddUpdatePARRequest',
        components: {
            swiper,
            swiperSlide,
        },
        mixins: [commonMixins],
        data() {
            return {
                documentArr: [],
                swiperOptionAttachments: {
                    slidesPerView: 14.5,
                    spaceBetween: 8,
                    freeMode: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1500: {
                            slidesPerView: 12.5
                        },
                        1400: {
                            slidesPerView: 11.5
                        },
                        1300: {
                            slidesPerView: 10.4
                        },
                        1200: {
                            slidesPerView: 8.5
                        },
                        1000: {
                            slidesPerView: 7.5
                        },
                        667: {
                            slidesPerView: 5.5
                        },
                        480: {
                            slidesPerView: 3.5
                        },
                        360: {
                            slidesPerView: 3.4
                        }
                    }
                },
                lightboxImages: [],
                viewImage: '',
                index: 0,
                loadPARData: '',
            }
        },
        watch: {
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("PARRequest");
            if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                self.getPARRequestById();
            }
        },
        methods: {
            buttonBack() {
                self.$router.push('/par/request/list');
            },
            getPARRequestById: function() {
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tkn")
                    },
                    params: {
                        id: self.$route.params.id
                    }
                };
                HTTP.get('/par/request/get', config)
                    .then(response => {
                        if(response.data.code == 200) {
                            self.loadPARData = response.data.content;
                            self.documentArr = response.data.content.document;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            openGallery: function (documents, index) {
                var self = this;
                var arr = [];
                var new_index = 0;
                $.each(documents, function (i) {
                    if (jQuery.inArray(documents[i].doc_extension.toLowerCase(), exten) !== -1) {
                        if (i == index) {
                            index = new_index;
                        }
                        arr.push(documents[i].media_path);
                        new_index = new_index + 1;
                    }
                });
                self.loadImagesInLightBox(arr, index);
            },
            onCancel: function (type) {
            },
            changeImage: function (move) {
                var self = this;
                if (move == 'next') {
                    self.index = self.index + 1;
                    if (self.lightboxImages.length <= self.index) {
                        self.index = 0;
                    }
                } else {
                    self.index = self.index - 1;
                    if (self.index < 0) {
                        self.index = (self.lightboxImages.length - 1);
                    }
                }
                self.viewImage = self.lightboxImages[self.index];
            },
            /* set images to gallery view */
            loadImagesInLightBox: function (arr, index) {
                var self = this;
                self.lightboxImages = arr;
                self.index = index;
                self.viewImage = self.lightboxImages[self.index];
                self.$refs.myModalRef.show();
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Forms/PARRequest/ViewPARRequest.vue